export default ({ request }) => ({
  SYS_PARAMS_GET_VALUE(paramID) {
    return request({
      url: `/sys/parameter/getParamValue/${paramID}`,
      method: 'GET',
    })
  },
  SYS_PARAMS_DETAIL(data = {}) {
    return request({
      url: `/sys/parameter/detail`,
      method: 'POST',
      data,
    })
  },
})
